import React, {Component} from 'react';
import {connect} from 'react-redux';

import {Alert, Button} from 'reactstrap';
import {Field, FieldArray, reduxForm} from 'redux-form';

import {handleInviteTenants} from '../actions/owner';
import PolyUtil from '../../../util/PolyUtil';
import {InputField} from '../../../validation/ReduxFormInput';
import CircleButton from '../../../components/controls/buttons/CircleButton';
import Loader from "../../../components/display/Loader";

class InviteTenantForm extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    keyPress = e => {
        if(e.keyCode === 13){
            this._fields.push({});
            setTimeout(() => {this._renderedFields.focus();},0); // focus newly created input
            e.preventDefault()
        }
    }

    componentDidMount(){
        this._fields.insert(0, {}); // add 2nd field and activate FieldArray
    }

    content = () => {
        const {error, handleSubmit, _handleInviteTenants, pristine, submitting, display_address} = this.props;
        const renderSubFields = (member, index, fields) => (
            <tr key={index}>
                <td>
                    <Field
                        name={`${member}.invitationCode`}
                        type="text"
                        component={InputField}
                        input={{
                            'onKeyDown': this.keyPress,
                            'getRef': (node) => this._renderedFields = node,
                            'tabIndex': 0
                        }}
                    />
                </td>
                {/* TODO: Re-add email feature
                <td>
                    <p className="mb-3">or</p>
                </td>
                <td>
                    <Field
                        name={`${member}.email`}
                        type="text"
                        component={InputField}
                    />
                </td>
                */}
            </tr>
        )
        const renderMembers = ({ fields, display_address }) => (
            <div>
                <h5>Property: {display_address}</h5>
                <hr/>
                <p>For each tenant, please enter their PolyRents invitation code.</p>
                <table width="100%" cellPadding="5">
                    <thead>
                    <tr>
                        <th>Invitation Code</th>
                        <th />
                    </tr>
                    </thead>
                    <tbody>
                        {fields.map(renderSubFields)}
                    </tbody>
                </table>
                <div className="center mb-3">
                    <CircleButton nomargin className="mx-1" color="success"  ref={() => this._fields = fields} onClick={() => fields.push({}) && console.log(fields.getAll())} outline><i title="Add" className="fa fa-plus" /></CircleButton>
                    <CircleButton nomargin className="mx-1" color="primary" onClick={() => fields.length > 1 ? fields.pop() : null} outline><i title="Remove" className="fa fa-trash" /></CircleButton>
                </div>
            </div>
        )
        return (
            <div>
                <form onSubmit={handleSubmit(_handleInviteTenants)}>
                    <FieldArray name="tenants" component={renderMembers} props={{display_address: display_address}} />
                    <div className="center">
                        <Button color="success" type="submit" disabled={pristine || submitting}>Invite</Button>
                    </div>
                    {
                        error &&
                        <div className="center" style={{marginTop: '5px'}}>
                            <Alert color="danger">
                                {error}
                            </Alert>
                        </div>
                    }
                </form>
            </div>
        );
    };

    render() {
        return PolyUtil.propsReady(this.props, ['display_address']) ? this.content() : <Loader spin isLoading/>;
    }
}

const validate = values => {
    const errors = {};

    !values.rent && (errors.rent = 'Required');
    !values.security_deposit && (errors.security_deposit = 'Required');
    !values.lease_length && (errors.lease_length = 'Required');

    (values.rent && values.rent <= 0) && (errors.rent = 'Must be greater than 0');
    (values.security_deposit && values.security_deposit <= 0) && (errors.security_deposit = 'Must be greater than 0');
    (values.lease_length && values.lease_length <= 0) && (errors.lease_length = 'Must be greater than 0');

    return errors;
};

InviteTenantForm = reduxForm({
    form: 'inviteTenantForm',
    initialValues: {
        tenants: [{}]
    },
    validate
})(InviteTenantForm);

const mapStateToProps = (state, props) => ({
    display_address: PolyUtil.getPropertyStreetAddress(state.owner.properties.find((property) => {
        return property.id === props.propId;
    })),
    id: props.propId
});

const mapDispatchToProps = (dispatch, props) => {
    return {
        _handleInviteTenants(data) {
            return dispatch(handleInviteTenants(data, props.propId, props.display_address));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(InviteTenantForm);


// WEBPACK FOOTER //
// ./src/containers/owner/listings/InviteTenantForm.js